import { Grid } from '@mui/material';
import FormInputLabel from 'common/FormInputLabel';
import Subtext from 'common/Subtext';

export default function FormTextAreaInput({
    name,
    label,
    subText,
    labelSize,
    noLabel = false,
    textSize,
    isTextFeild = true,
    value,
    handleChange,
    placeholder,
    helperText,
    additionAction,
    subTextBottom,
    required = false,
    error,
    style,
}) {
    return (
        <>
            {!noLabel && <FormInputLabel label={label} subText={subText} labelSize={labelSize} required={required} />}
            {subTextBottom && <Subtext>{subTextBottom}</Subtext>}

            {isTextFeild && (
                <Grid
                    item
                    xs={textSize}
                    sx={{
                        marginBottom: style?.marginBottom ? style?.marginBottom : '16px',
                        ...style,
                    }}
                >
                    {helperText && (
                        <span className={'help-text'} style={{marginBottom: '12px', display: 'block'}}>
                            {helperText}
                        </span>
                    )}

                    <textarea
                        name={name}
                        value={value}
                        onChange={handleChange}
                        aria-label="minimum height"
                        rows={8}
                        placeholder={placeholder}
                        style={{
                            width: '100%',
                            padding: '8px',
                            fontSize: '14px',
                            color: '#000000',
                            backgroundColor: '#f5f1ed',
                            border: error ? '1px solid #dc3545' : '1px solid #CBC1B7',
                            borderRadius: '8px',
                            transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            if (!error) {
                                e.target.style.borderColor = '#ff5f39';
                                e.target.style.backgroundColor = 'white';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!error) {
                                e.target.style.borderColor = '#CBC1B7';
                                e.target.style.backgroundColor = '#f5f1ed';
                            }
                        }}
                        onFocus={(e) => {
                            if (!error) {
                                e.target.style.borderColor = '#ff5f39';
                                e.target.style.backgroundColor = 'white';
                                e.target.style.boxShadow = '0 0 0 2px rgba(255, 95, 57, 0.1)';
                            }
                        }}
                        onBlur={(e) => {
                            if (!error) {
                                e.target.style.borderColor = '#CBC1B7';
                                e.target.style.backgroundColor = '#f5f1ed';
                                e.target.style.boxShadow = 'none';
                            }
                        }}
                        required = {required}
                        aria-required={required}
                        aria-invalid={!!error}
                    ></textarea>
                    {error && (
                        <div style={{ 
                            color: '#dc3545', 
                            fontSize: '12px', 
                            marginTop: '4px',
                            fontFamily: 'Poppins, sans-serif'
                        }}>
                            {error}
                        </div>
                    )}

                    {additionAction && (
                        <div style={{marginTop: '8px'}}>
                            {additionAction}
                        </div>
                    )}
                </Grid>
            )}
        </>
    );
}
